// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-navigation-footer-column p{color:#fff !important;font-size:0.875rem;line-height:18px;font-family:\"Merriweather\",Georgia,serif}.czt-navigation-footer-column .czt-navigation-menu~.czt-navigation-menu{margin-top:2em}", ""]);
// Exports
module.exports = exports;
